import Joi from 'joi';

export const formValidationSchema = Joi.object({
  first_name: Joi.string().min(1).messages({
    'string.empty': `First Name is required`,
  }),
  last_name: Joi.string().min(1).messages({
    'string.empty': `Last Name is required`,
  }),
  email: Joi.string()
    .email({
      minDomainSegments: 2,
      tlds: { allow: false },
    })
    .messages({
      'string.empty': `Email cannot be empty`,
      'string.email': 'Invalid email address',
    }),
  password: Joi.string()
    .pattern(
      new RegExp(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@!%*?&])[A-Za-z\\d@!%*?&]{8,12}$'
      )
    )
    .messages({
      'string.empty': `Password cannot be empty`,
      'string.pattern.base': `Password does not meet requirements`,
    }),
  confirmPassword: Joi.string()
    .valid(Joi.ref('password'))
    .label('Confirm Password')
    .messages({
      'any.only': 'Passwords do not match',
      'string.empty': 'Confirm Password cannot be empty',
    }),
  newsletter: Joi.boolean().messages({
    'any.required': `Email updates is a required field`,
  }),
  university_name: Joi.string().min(1).messages({
    'string.empty': `University name cannot be empty`,
  }),
  department: Joi.string().min(1).messages({
    'string.empty': `Department cannot be empty`,
  }),
  title: Joi.string().min(1).messages({
    'string.empty': `Job Title cannot be empty`,
  }),
  org_department: Joi.string().min(1).messages({
    'string.empty': `Department cannot be empty`,
  }),
  org_title: Joi.string().min(1).messages({
    'string.empty': `Job Title cannot be empty`,
  }),
  universityRole: Joi.boolean(),
  industry: Joi.string().min(1).messages({
    'any.required': `Email updates is a required field`,
  }),
  otherIndustry: Joi.string().min(1).messages({
    'string.empty': `Industry cannot be empty`,
  }),
  is_naspaa: Joi.any(),
  is_university: Joi.any(),
  is_faculty: Joi.any(),
  is_university_staff: Joi.any(),
  valid_univ_domain: Joi.any(),
  organization_name: Joi.string().min(1).messages({
    'string.empty': `Organization name cannot be empty`,
  }),
});
